import React, { useState, Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import IconFolderClose from '../ACShared/IconFolderClose';
import DefinitionFolderMenu from './AutocodeMenu/DefinitionFolderMenu';
import definitionSaveButton from '../../../images/Autocode/definitionSaveButton.svg';
import definitionCancelButton from '../../../images/Autocode/definitionCancelButton.svg';
import { useACProjectContext } from '../ACContext/ACDefinitionContext';
import { createNewDefinition } from '../../../actions/definitionActions';

const ACDefinitionFolderItem = props => {
  const {
    folder,
    onSave,
    onDelete,
    canEdit,
    onLeafNodeClicked,
    selectedFolder,
    showDefFolderEllipsis,
  } = props;
  const [inputText, setInputText] = useState({});
  const [editedName, setEditedName] = useState(folder.folderName);
  const [editing, setEditing] = useState(false);
  const [canpaste, setCanpaste] = useState(false);
  const {
    moduleStudy,
    activeAccountId,
    definitionTarget,
  } = useACProjectContext();
  const dispatch = useDispatch();

  const saveInput = () => {
    setEditing(false);
    onSave({ ...folder, folderName: editedName });
  };
  const cancelInput = () => {
    setEditing(false);
    setEditedName(folder.folderName);
  };

  const duplicateFolder = e => {
    const key = e.which || e.keyCode; // keyCode detection
    const ctrl = e.ctrlKey ? true : key === 17;

    if (key === 86 && ctrl && canpaste) {
      // ("Ctrl + V Pressed !");
      const patchDefinition = {
        token: '',
        ssid: moduleStudy.ss === 'SIMMONS' ? 1 : 2,
        accountId: activeAccountId,
        productNo: moduleStudy.pn,
        thisStudy: false,
        folderName: `Copy_${folder.folderName}`,
        shared: false,
        newExpressions: definitionTarget.data.map(({ title, expression }) => ({
          id: 0,
          name: title,
          expression,
        })),
        sort: 'defSort=sc-a,ct-d',
      };
      setCanpaste(!canpaste);
      dispatch(createNewDefinition(patchDefinition));
    } else if (key === 67 && ctrl) {
      // ("Ctrl + C Pressed !");
      setCanpaste(!canpaste);
    }
  };

  useEffect(() => {
    if (editing) {
      inputText.focus();
      inputText.select();
    }
  }, [inputText]);

  return (
    <div
      tabIndex="-1"
      onKeyDown={duplicateFolder}
      style={{ outline: 'none' }}
      key={folder.definitionId}
      className={
        canEdit && editing
          ? 'ac--def__folder-list--item-editable'
          : folder.definitionId ===
            (selectedFolder &&
              selectedFolder.selectedFolder &&
              selectedFolder.selectedFolder.definitionId)
          ? ' ac--def__folder-list--item ac--def__folder-list--item-active'
          : 'ac--def__folder-list--item'
      }
    >
      <span className="ac--def__folder-icon">
        <IconFolderClose
          fill={
            canEdit && editing
              ? '#7994BB'
              : folder.definitionId ===
                (selectedFolder &&
                  selectedFolder.selectedFolder &&
                  selectedFolder.selectedFolder.definitionId)
              ? '#ffffff'
              : '#7994BB'
          }
        />
      </span>
      {canEdit && editing ? (
        <Fragment>
          <input
            ref={el => {
              setInputText(el);
            }}
            className="ac--def__folder-name--input"
            type="text"
            value={editedName}
            onChange={e => setEditedName(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') saveInput();
              else if (e.key === 'Escape') cancelInput();
            }}
            onBlur={() => saveInput()}
          />
          <span className="row pull-right ac--def__folder-btns">
            <img
              className="ac--def__folder-save--btn"
              src={definitionSaveButton}
              alt="save"
              title="Save"
              onMouseDown={saveInput}
            />
            <img
              className="ac--def__folder-cancel--btn"
              src={definitionCancelButton}
              alt="cancel"
              title="Cancel"
              onMouseDown={cancelInput}
            />
          </span>
        </Fragment>
      ) : (
        <Fragment>
          <span
            onClick={() => {
              onLeafNodeClicked(folder);
            }}
            onDoubleClick={() => setEditing(true)}
            className="ac--def__folder--button-text"
          >
            {folder.folderName}
          </span>
          <span
            style={{ marginRight: '0px' }}
            className="row pull-right ac--def__folder-list--item-menu"
            onClick={() => onLeafNodeClicked(folder)}
          >
            {showDefFolderEllipsis && <DefinitionFolderMenu
              item={folder}
              fill={
                folder.definitionId ===
                (selectedFolder &&
                  selectedFolder.selectedFolder &&
                  selectedFolder.selectedFolder.definitionId)
                  ? 'white'
                  : 'black'
              }
              onEditName={() => setEditing(true)}
              onDelete={() => onDelete(folder)}
            />}
          </span>
        </Fragment>
      )}
    </div>
  );
};

ACDefinitionFolderItem.propTypes = {
  folder: PropTypes.shape({
    folderName: PropTypes.string,
    definitionId: PropTypes.string,
  }),
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  canEdit: PropTypes.bool,
  onLeafNodeClicked: PropTypes.func,
  selectedFolder: PropTypes.shape({
    selectedFolder: {
      definitionId: PropTypes.string,
    },
  }),
  showDefFolderEllipsis: PropTypes.bool,
};

export default ACDefinitionFolderItem;
